<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col id="base" md="12" style="display: flex; flex-flow: column; height: 100%;" class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row class="sticky" justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; max-height: 80px">
                <v-col class="ml-4 mt-0 pt-1 RestoRegular">
                    <v-row style="font-size: 18px; color: #4D4D4D; max-width: 300px" class="pt-2">
                        Un par de datos más para validar el paso anterior
                    </v-row>
                    <!-- ##### ALERTA FALTA CAMPO ##### -->
                    <!-- <v-snackbar v-model="isError" class="font" :top="true" color="warning">
                        ¡Falta llenar algún campo!
                    </v-snackbar> -->
                </v-col>    
            </v-row>

            <!-- New content -->
            <v-row style="flex-grow : 1;" class="py-0 my-0" >
                <v-col style="height: 100%" class="py-0 my-0">
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.calle" :rules="[rules.required]" label="Calle" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row>
                    <v-row style="margin: 0 auto; max-width: 350px;" class="my-0 py-0">
                        <v-col class="pl-0">
                            <v-text-field v-model="address.num_exterior" :rules="[rules.required]" label="No. Exterior" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                        </v-col>
                        <v-col class="pr-0">
                            <v-text-field v-model="address.num_interior" label="No. Interior" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                        </v-col>
                    </v-row>                    
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.colonia" :rules="[rules.required]" label="Colonia" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.cp" :rules="[rules.required]" label="Código Postal" class="mt-1 mb-2" hide-details='true' id="cp" outlined></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.referencias" :rules="[rules.required]" label="Referencias" class="mt-1 mb-2" hide-details='true' maxlength="50" outlined></v-text-field>
                    </v-row> 
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.alias" :rules="[rules.required]" label="Alias" class="mt-1 mb-2"  hide-details='true' outlined ></v-text-field>
                    </v-row> 
                     <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-input hint="Ej. casa, oficina, negocio, trabajo etc..." persistent-hint></v-input>
                    </v-row>   
                            <!-- <v-btn v-else @click="alertMessage()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; " >
                                <span style="float: left; padding-left:0px;">Completa los campos restantes</span>
                                <v-spacer></v-spacer>
                                <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                            </v-btn> -->
                </v-col>
            </v-row>

            <!-- Button Continue -->
            <v-row justify="center" class="mt-2" style="max-height: 70px; margin: 0 auto; width: 100%"  >
                <!-- v-if="checkAddress==true" -->
                <v-btn @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>    
            <v-row justify="center" class="mt-4" style="max-height: 70px; margin: 0 auto; width: 100%"  >
                <v-btn @click="$router.push({ name: 'ubication'}); " class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px;">Regresar</span>
                    <v-spacer></v-spacer>
                </v-btn>
            </v-row>  
        </v-col>
    </v-row>
</template>

<script>
import Inputmask from 'inputmask';
// import $ from 'jquery'
// require('jquery-mask-plugin');
export default {
    data()
    {
        return{
                address:{
                    id_cliente:'',
                    alertM:false,
                    alias:'',
                    predeterminada:'',
                    calle:localStorage.getItem("calle"),
                    num_exterior:localStorage.getItem("num_exterior"),
                    num_interior:'',
                    cp:localStorage.getItem("cp"),
                    colonia:localStorage.getItem("colonia"),
                    ciudad:localStorage.getItem("ciudad"),
                    estado:localStorage.getItem("estado"),
                    pais:'México',
                    referencias:'',
                },
                rules:
                {
                    required: value => !!value || ''
                },
                longitude:null,
                latitude:null,
                isError: false,
                itemsAlias:['Casa', 'Oficina', 'Negocio', 'Edificio', 'Departamento', 'Otro']
        }
    },
    mounted() {
        var cp = document.getElementById("cp");
        var cpm = new Inputmask("99999",{placeholder: " "});
        cpm.mask(cp);
        // $('document').ready(function() {
        //     $("#cp").mask("00000");            
        // });
    },
    computed:{
      checkAddress: function (){
        if (this.address.calle && this.address.num_exterior && this.address.colonia && this.address.cp) { 
          return true 
        } return false;
      },
    },
    methods:
    {
        addAddress(){
            this.token=localStorage.getItem("token");
            this.longitude=localStorage.getItem("longitude");
            this.latitude=localStorage.getItem("latitude");
            //this.token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1OTA2ODU2NDksImF1ZCI6IjE3MDc2OGVjN2Y1M2M2ZGE0OGVmNDc1NDAzNmE5ODg2YzkwN2QzMTAiLCJkYXRhIjp7ImlkIjoiOSIsIm5hbWUiOiJlbnJpcXVlLnJhbWlyZXpAc3d5dGkuY29tLm14In19.R6ywm-LJVSwkSKrBEs8MIOwlXfwixn-hGvMb1ngoPuU";
            this.address.alias='name';
            this.address.id_cliente='9';
            this.address.predeterminada='S';
            const addressAdd=this.address;
            // console.log(addressAdd);
            // console.log(this.token);            
            this.$store.dispatch("POST", {url: '/altaD', body: addressAdd, headers: {'x-auth-token': this.token}})
                .then(response => {
                    console.log(response);
                })// eslint-disable-next-line
                .catch(error => {
                    // eslint-disable-next-line
                    console.log("Error: " + error);
                });           
        },
        alertMessage(){
            this.alertM=true;
        },
        goTo() 
        {
            if(( !!this.address.calle && !!this.address.num_exterior && !!this.address.colonia && !!this.address.cp && !! this.address.referencias && !! this.address.alias)){
                var dirTemp = {
                    alias: null,
                    predeterminada: null,
                    calle: null,
                    num_exterior: null,
                    num_interior: null,
                    cp: null,
                    colonia: null,
                    ciudad: null,
                    estado: null,
                    pais: null,
                    referencias: null,
                    longitud: null,
                    latitud: null
                }
                dirTemp.alias = this.address.alias;
                dirTemp.predeterminada = 'S',
                dirTemp.calle = this.address.calle, 
                dirTemp.num_exterior = this.address.num_exterior,
                dirTemp.num_interior = this.address.num_interior, 
                dirTemp.cp = this.address.cp,
                dirTemp.colonia = this.address.colonia,
                dirTemp.ciudad = this.address.ciudad,
                dirTemp.estado = this.address.estado,
                dirTemp.pais = this.address.pais,      
                dirTemp.referencias = this.address.referencias,
                dirTemp.longitud = localStorage.getItem("longitude"),  
                dirTemp.latitud = localStorage.getItem("latitude"),  
                this.$store.state.newUserData.direccion = dirTemp;
                // console.log("DIRECCIONES: ",this.$store.state.newUserData.direccion);
                this.$router.push({ name: 'registerStep3'});
            }
            else
            {
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Falta llenar algún campo";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
            }
        },

    }
}
</script>

<style scoped>
.disable-events 
{
    pointer-events: none;
}
.font
{
    font-size: 16px;
}
div.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: -1px;
        z-index: 1;
    }
</style>